import { Link } from "react-router-dom";

// components

import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";
import enarmBackground from "assets/img/enarm-apex-background.png";
import enarmApexLogo from "assets/img/enarm-apex-logo.png";
import enarmApexLogoBlanco from "assets/img/enarm-apex-logo-blanco2.png";
import enarmApexEstudiando from "assets/img/enarm-apex-estudiando.png";
import enarmApexDoctores from "assets/img/enarm-apex-doctores.png";

export default function Landing() {
  return (
    <>
      <style>
        {`
          .pricing-section-offset {
            margin-top: -14rem;
          }

          .pricing-cards-row {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: stretch;
            gap: 1rem;
          }

          .pricing-card-col {
            width: 100%;
            padding-left: 0;
            padding-right: 0;
            display: flex;
            justify-content: center;
            align-items: stretch;
          }

          .pricing-card {
            width: 100%;
            max-width: 320px;
            height: 100%;
            display: flex;
            flex-direction: column;
          }

          .pricing-card-content {
            display: flex;
            flex-direction: column;
            height: 100%;
          }

          .pricing-card-cta {
            margin-top: auto;
            padding-top: 1.5rem;
          }

          .feature-cards-row {
            align-items: stretch;
            row-gap: 1rem;
          }

          .feature-card-col {
            display: flex;
          }

          .feature-card {
            width: 100%;
            height: 100%;
          }

          .feature-details-offset {
            margin-top: 6rem;
          }

          .focus-copy-offset {
            margin-top: 2rem;
          }

          .landing-tools-title-offset {
            margin-top: 2.5rem;
          }

          .landing-hero-section {
            padding-top: 4rem;
            padding-bottom: 8rem;
          }

          .landing-hero-shell {
            min-height: 75vh;
          }

          @media (max-width: 639px) {
            .feature-details-offset {
              margin-top: 7rem;
            }
          }

          @media (max-width: 1023px) {
            .pricing-section-offset {
              margin-top: -4rem;
            }
          }

          @media (min-width: 768px) {
            .focus-copy-offset {
              margin-top: 0;
            }

            .landing-tools-title-offset {
              margin-top: 0;
            }

            .feature-cards-row {
              row-gap: 0;
            }

            .pricing-cards-row {
              flex-wrap: nowrap;
              max-width: 100%;
              margin-left: auto;
              margin-right: auto;
              padding: 0 0.5rem;
              gap: 6rem;
            }

            .pricing-card-col {
              width: auto;
              padding-left: 0.25rem;
              padding-right: 0.25rem;
            }
          }

          @media (min-width: 768px) and (max-width: 1023px) {
            .landing-hero-section {
              padding-top: 2rem;
              padding-bottom: 3.5rem;
            }

            .landing-hero-shell {
              min-height: 62vh;
            }

            .landing-tools-title-offset {
              margin-top: 4rem;
            }

            .pricing-section-offset {
              margin-top: -8rem;
            }
          }
        `}
      </style>
      <Navbar transparent />
      <main>
        <div className="relative landing-hero-section landing-hero-shell flex content-center items-center justify-center">
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage:
                "url(" + enarmBackground + ")",
            }}
          ></div>
          <div className="absolute top-0 w-full h-full bg-black opacity-50"></div>
          <div className="container relative mx-auto">
            <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-8/12 px-4 ml-auto mr-auto text-center">
                <div>
                  <img
                    alt="ENARM Apex"
                    src={enarmApexLogoBlanco}
                    className="mx-auto mb-6 mt-8"
                    style={{ maxHeight: "120px" }}
                  />
                  <p className="mt-4 text-lg text-blueGray-200">
                    ENARM Apex reúne simuladores, práctica por temas,
                    flashcards y estadísticas para que estudies con dirección,
                    midas tu avance y llegues al examen con más confianza.
                  </p>
                  <div className="mt-8">
                    <Link
                      to="/auth"
                      className="bg-indigo-500 text-white active:bg-indigo-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-2 mb-2 ease-linear transition-all duration-150 inline-block"
                    >
                      Empieza ahora gratis
                    </Link>
                    <Link
                      to="/auth"
                      className="bg-white text-blueGray-700 active:bg-blueGray-50 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-2 mb-2 ease-linear transition-all duration-150 inline-block"
                    >
                      Ir al dashboard
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>
        </div>

        <section className="pb-20 bg-blueGray-200 -mt-24">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap feature-cards-row">
              <div className="w-full md:w-4/12 px-4 text-center feature-card-col">
                <div className="feature-card relative flex flex-col min-w-0 break-words bg-white mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-indigo-500">
                      <i className="fas fa-clipboard-list"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Simulador ENARM</h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      Responde exámenes cronometrados con una experiencia
                      cercana al formato real y revisa tus resultados al
                      terminar.
                    </p>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-4/12 px-4 text-center feature-card-col">
                <div className="feature-card relative flex flex-col min-w-0 break-words bg-white mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-indigo-500">
                      <i className="fas fa-stethoscope"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Zona de práctica</h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      Refuerza materias específicas, ajusta dificultad y ataca
                      los temas que más impacto tienen en tu desempeño.
                    </p>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-4/12 px-4 text-center feature-card-col">
                <div className="feature-card relative flex flex-col min-w-0 break-words bg-white mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-indigo-500">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <h6 className="text-xl font-semibold">Estadísticas claras</h6>
                    <p className="mt-2 mb-4 text-blueGray-500">
                      Identifica fortalezas, áreas por reforzar y progreso por
                      especialidad para convertir datos en decisiones de estudio.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center feature-details-offset">
              <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                  <i className="fas fa-user-md text-xl"></i>
                </div>
                <h3 className="text-3xl mb-2 font-semibold leading-normal">
                  Todo tu entrenamiento ENARM en un solo lugar
                </h3>
                <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                  ENARM Apex está diseñado para estudiantes de medicina que
                  necesitan estudiar con estructura: practicar preguntas,
                  simular exámenes completos y repasar conceptos clave sin
                  perder de vista su avance.
                </p>
                <p className="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-600">
                  Cada herramienta se conecta con tu desempeño para que sepas
                  qué dominar, qué reforzar y cuándo estás listo para subir el
                  nivel de dificultad.
                </p>
                <Link to="/auth" className="font-bold text-blueGray-700 mt-8 mb-8 inline-block">
                  Crear mi plan de estudio
                </Link>
              </div>

              <div className="w-full md:w-5/12 lg:w-4/12 px-4 mr-auto ml-auto">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-indigo-500">
                  <img
                    alt="Vista del simulador de exámenes de ENARM Apex"
                    src={enarmApexEstudiando}
                    className="w-full align-middle rounded-t-lg"
                  />
                  <blockquote className="relative p-8 mb-4">
                    <svg
                      preserveAspectRatio="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 583 95"
                      className="absolute left-0 w-full block h-95-px -top-94-px"
                    >
                      <polygon
                        points="-30,95 583,95 583,65"
                        className="text-indigo-600 fill-current"
                      ></polygon>
                    </svg>
                    <h4 className="text-xl font-bold text-white">
                      Entrena como si ya fuera el examen
                    </h4>
                    <p className="text-md font-light mt-2 text-white">
                      Simula sesiones completas, revisa aciertos y errores, y
                      aprende a administrar tiempo, seguridad y precisión.
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative py-20">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-white fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4">
            <div className="items-center flex flex-wrap">
              <div className="w-full md:w-5/12 lg:w-4/12 ml-auto mr-auto px-4">
                <img
                  alt="Zona de práctica de ENARM Apex"
                  className="max-w-full rounded-lg shadow-lg"
                  src={enarmApexDoctores}
                />
              </div>
              <div className="w-full md:w-5/12 ml-auto mr-auto px-4 focus-copy-offset">
                <div className="md:pr-12">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-indigo-500">
                    <i className="fas fa-brain text-xl"></i>
                  </div>
                  <h3 className="text-3xl font-semibold">
                    Estudia con enfoque, no con intuición
                  </h3>
                  <p className="mt-4 text-lg leading-relaxed text-blueGray-500">
                    La preparación para el ENARM exige constancia y medición.
                    ENARM Apex te ayuda a convertir cada sesión en información
                    útil para tu siguiente repaso.
                  </p>
                  <ul className="list-none mt-6">
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-indigo-600 bg-indigo-200 mr-3">
                            <i className="fas fa-book-medical"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Práctica por materias y especialidades
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-indigo-600 bg-indigo-200 mr-3">
                            <i className="fas fa-layer-group"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Flashcards para repaso rápido y constante
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-indigo-600 bg-indigo-200 mr-3">
                            <i className="fas fa-chart-pie"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-blueGray-500">
                            Reportes para ajustar tu estrategia
                          </h4>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pb-20 relative block bg-indigo-900">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-indigo-500 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4 lg:pt-24 lg:pb-64">
            <div className="flex flex-wrap text-center justify-center">
              <div className="w-full lg:w-6/12 px-4 landing-tools-title-offset">
                <h2 className="text-4xl font-semibold text-white">
                  Herramientas hechas para el ritmo del ENARM
                </h2>
                <p className="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400">
                  Combina sesiones largas de simulación con práctica dirigida,
                  repaso espaciado y métricas accionables. Todo pensado para
                  que avances con claridad semana a semana.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap mt-12 justify-center">
              <div className="w-full md:w-4/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fas fa-stopwatch text-xl"></i>
                </div>
                <h6 className="text-xl mt-5 font-semibold text-white">
                  Simulacros cronometrados
                </h6>
                <p className="mt-2 mb-4 text-blueGray-400">
                  Practica resistencia, manejo del tiempo y toma de decisiones
                  bajo condiciones similares a las del examen.
                </p>
              </div>
              <div className="w-full md:w-4/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fas fa-bullseye text-xl"></i>
                </div>
                <h5 className="text-xl mt-5 font-semibold text-white">
                  Práctica personalizada
                </h5>
                <p className="mt-2 mb-4 text-blueGray-400">
                  Selecciona temas, número de preguntas y dificultad para
                  enfocarte en lo que necesitas reforzar.
                </p>
              </div>
              <div className="w-full md:w-4/12 px-4 text-center">
                <div className="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                  <i className="fas fa-chart-bar text-xl"></i>
                </div>
                <h5 className="text-xl mt-5 font-semibold text-white">
                  Seguimiento de desempeño
                </h5>
                <p className="mt-2 mb-4 text-blueGray-400">
                  Observa progreso general, precisión promedio y resultados por
                  especialidad para decidir tu siguiente sesión.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="relative block py-24 lg:pt-0 bg-indigo-900 pricing-section-offset">
          <div className="container mx-auto px-4">
            <div className="pricing-cards-row">
              <div className="pricing-card-col">
                <div
                  className="pricing-card relative min-w-0 break-words mb-6 shadow-xl rounded-lg bg-white"
                >
                  <div className="pricing-card-content px-5 py-6 md:px-6">
                    <div className="text-center">
                      <img
                        alt="ENARM Apex"
                        src={enarmApexLogo}
                        className="h-18 mx-auto mb-4"
                      />
                      <div className="mb-1 flex items-center justify-center gap-2">
                        <p
                          className="text-lg font-semibold text-blueGray-400"
                          style={{ textDecoration: "line-through" }}
                        >
                          $199
                        </p>
                        <p className="text-xs font-bold uppercase tracking-wide text-indigo-500">
                          Oferta por tiempo limitado
                        </p>
                      </div>
                      <h3
                        className="font-bold text-blueGray-900 leading-none"
                        style={{ fontSize: "3rem" }}
                      >
                        $149
                        <span className="text-3xl text-indigo-500 font-semibold">/mes</span>
                      </h3>
                      <span className="mt-4 inline-block bg-indigo-500 text-white text-lg font-semibold px-6 py-1 rounded-full shadow">
                        Primer mes gratis
                      </span>
                      <p className="mt-3 text-base font-semibold text-blueGray-500">
                        Cancela cuando quieras
                      </p>
                    </div>

                    <div className="border-t border-blueGray-200 mt-2 mb-2"></div>

                    <h4 className="text-2xl font-bold text-blueGray-900 mb-3 ml-6">Incluye:</h4>
                    <ul className="list-none text-lg text-blueGray-800 ml-6">
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Simulador
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Zona de practica
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Flashcards
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Estadisticas
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Progreso
                      </li>
                    </ul>

                    <div className="pricing-card-cta text-center">
                      <Link
                        to="/auth"
                        className="bg-indigo-500 text-white active:bg-indigo-600 text-lg font-semibold px-8 py-2 rounded-full shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 inline-block"
                      >
                        Comienza
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pricing-card-col">
                <div
                  className="pricing-card relative min-w-0 break-words mb-6 shadow-xl rounded-lg bg-white"
                >
                  <div className="pricing-card-content px-5 py-6 md:px-6">
                    <div className="text-center">
                      <img
                        alt="ENARM Apex"
                        src={enarmApexLogo}
                        className="h-18 mx-auto mb-4"
                      />
                      <div className="mb-1 flex items-center justify-center gap-2">
                        <p
                          className="text-lg font-semibold text-blueGray-400"
                          style={{ textDecoration: "line-through" }}
                        >
                          $1990
                        </p>
                        <p className="text-xs font-bold uppercase tracking-wide text-indigo-500">
                          Oferta por tiempo limitado
                        </p>
                      </div>
                      <h3
                        className="font-bold text-blueGray-900 leading-none"
                        style={{ fontSize: "3rem" }}
                      >
                        $1490
                        <span className="text-3xl text-indigo-500 font-semibold">/año</span>
                      </h3>
                      <span className="mt-4 inline-block bg-indigo-500 text-white text-lg font-semibold px-6 py-1 rounded-full shadow">
                        Primer mes gratis
                      </span>
                      <p className="mt-3 text-base font-semibold text-blueGray-500">
                        Cancela cuando quieras
                      </p>
                    </div>

                    <div className="border-t border-blueGray-200 mt-2 mb-2"></div>

                    <h4 className="text-2xl font-bold text-blueGray-900 mb-3 ml-6">Incluye:</h4>
                    <ul className="list-none text-lg text-blueGray-800 ml-6">
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Ahorra 2 meses
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Simulador
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Zona de practica
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Flashcards
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Estadisticas
                      </li>
                      <li className="py-1 flex items-center">
                        <i className="fas fa-check-circle text-indigo-500 mr-2"></i>
                        Progreso
                      </li>
                    </ul>

                    <div className="pricing-card-cta text-center">
                      <Link
                        to="/auth"
                        className="bg-indigo-500 text-white active:bg-indigo-600 text-lg font-semibold px-8 py-2 rounded-full shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 inline-block"
                      >
                        Comienza
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
